import { Logger } from "aws-amplify";

export default new Logger("@Interval Films", process.env.REACT_APP_LOG_LEVEL);
